import { render } from "./transaction.vue?vue&type=template&id=3e80dc1c&scoped=true"
import script from "./transaction.vue?vue&type=script&lang=js"
export * from "./transaction.vue?vue&type=script&lang=js"

import "./transaction.vue?vue&type=style&index=0&id=3e80dc1c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e80dc1c"]])

export default __exports__